<!-- A single row with a title and some data -->
<!-- FUTURE: Make this rely on external CSS classes to customize -->
<script lang="ts" setup>
    import { computed } from "vue"

    const props = withDefaults(defineProps<{
            title?: string,
            titleWidth?: number,   // Value must be between 1-12. Will be ignored if the titleClass is specified
            titleClass?: string,
            contentClass?: string
        }>(), 
        {
            titleWidth: 3
        });

    const safeTitleWidth = computed(() => {
        if (props.titleWidth < 1)
            return 3;
        if (props.titleWidth > 12)
            return 6;
        return props.titleWidth;
    });

    const titleClassValue = computed(() => {
        return props.titleClass ? props.titleClass : `col-sm-${safeTitleWidth.value}`;
    });

    const contentClassValue = computed(()=>{
        return props.contentClass ? props.contentClass : `col-sm-${12-safeTitleWidth.value}`;
    });
</script>

<template>
    <div class="row mb-1 container">
        <div :class="titleClassValue">
            <strong>{{title}}</strong>
        </div>
        <div :class="contentClassValue">
            <slot></slot>
        </div>
    </div>
</template>
